/* eslint-disable jsx-a11y/anchor-is-valid */
import { Text } from '../Text';
import styles from './horizontal-promotion.module.sass';
import { setSession } from '@intigral/utils/lib/browser-storage/localStorage';
import { SESSION_WCP } from '@intigral/constant';

interface IHorizontalPromotion {
    href?: string;
    onClick?: (item: any) => void;
    item: any;
    mobileImageSrc: string | undefined;
    mainImageSrc: string | undefined;
    title?: string;
    description?: string;
    rewindItem?: any;
}

const PromotionContent = ({
    title,
    description,
    mobileImageSrc,
    mainImageSrc,
}: Pick<IHorizontalPromotion, 'title' | 'description' | 'mobileImageSrc' | 'mainImageSrc'>) => (
    <>
        <picture>
            <source media={`(min-width: 924px)`} srcSet={mainImageSrc} />
            <img className={styles['promotion-img']} src={mobileImageSrc} alt="Promotion poster" draggable="false" />
        </picture>
        <div className={styles['promotion-text']}>
            <Text
                as="h2"
                variant="h2"
                margin="0"
                alignment="start"
                title={title}
                className={styles['promotion-text-title']}
                size={{ default: '16', md: '30' }}
            >
                {title ?? null}
            </Text>
            <Text
                as="p"
                margin="0"
                color="gray"
                alignment="start"
                title={description}
                className={styles['promotion-text-description']}
                size={{ default: '14', md: '16' }}
            >
                {description ?? null}
            </Text>
        </div>
    </>
);

export const HBanner = ({
    title,
    description,
    href,
    rewindItem,
    onClick,
    item,
    mobileImageSrc,
    mainImageSrc,
}: IHorizontalPromotion) => {
    const handleClick = () => {
        onClick && onClick(item);
        if (rewindItem) {
            setSession(SESSION_WCP.PROMO_REWIND, rewindItem);
        }
    };

    const content = (
        <PromotionContent
            title={title}
            description={description}
            mobileImageSrc={mobileImageSrc}
            mainImageSrc={mainImageSrc}
        />
    );

    if (item?.promoType === 'SUBSCRIPTION' || item?.promoType === 'TIER') {
        return (
            <a href={href} className={styles.promotion} onClick={handleClick}>
                {content}
            </a>
        );
    }

    return (
        <div
            role="button"
            tabIndex={0}
            className={styles.promotion}
            onClick={handleClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick();
                }
            }}
        >
            {content}
        </div>
    );
};

export default HBanner;
